/**
 * App metadata / feature flags (v4.41). Reads GET /meta/app once and caches the
 * result for the session, so flag checks don't refetch on every render.
 */

import api from './api.js';

const TTL_MS = 60000; // refetch at most once a minute, so an admin flag flip propagates
let _cache = null;
let _cachedAt = 0;

export async function getAppMeta() {
  if (_cache && Date.now() - _cachedAt < TTL_MS) return _cache;
  try {
    const res = await api.get('/meta/app');
    _cache = res.data?.data || {};
  } catch {
    _cache = _cache || {};
  }
  _cachedAt = Date.now();
  return _cache;
}

/** Feature flags object, e.g. { rankings_relais_enabled: false }. */
export async function getFeatures() {
  const meta = await getAppMeta();
  return meta.features || {};
}
